export default () => {
    return {
        anfaelle: []
    }
}